import { connect } from "react-redux";
import ImportForm from "../components/admin/ImportForm";
import { importFile } from "../redux/actions/clientActions";
import { currentClientSelector } from "../redux/selectors/auth";

const mapStateToProps = (state, ownProps) => {
	const token = state.auth.token;
	const currentClient = currentClientSelector(state);
	return {
		token,
		currentClient
	};
};

const mapDispatchToProps = dispatch => {
	return {
		importFile: (uri, body) => {
			dispatch(importFile(uri, body));
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ImportForm);



// WEBPACK FOOTER //
// src/containers/ImportFormContainer.js